module.exports = __webpack_public_path__ + "img/quantum-reconhecimento-placa-1-250x180.80c84e2a.png";